import { NgModule, CUSTOM_ELEMENTS_SCHEMA } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';

//Material Imports
import { MatMenuModule } from '@angular/material/menu';
import { MatButtonModule } from '@angular/material/button';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatPaginatorModule } from '@angular/material/paginator';
import { MatSortModule } from '@angular/material/sort';
import { MatTableModule } from '@angular/material/table';
import { MatInputModule } from '@angular/material/input';
import { MatCardModule } from '@angular/material/card';
import { MatSelectModule } from '@angular/material/select';
import { MatNativeDateModule } from '@angular/material/core';
import { MatDatepickerModule } from '@angular/material/datepicker';
import { MatDialogModule } from '@angular/material/dialog';
import { NgxMaterialTimepickerModule } from 'ngx-material-timepicker';
import { MatExpansionModule } from '@angular/material/expansion';
import { MatSlideToggleModule } from "@angular/material/slide-toggle";
import { MatTreeModule } from '@angular/material/tree';
import { MaterialModule } from 'src/app/material-module';
import { MatTimepickerModule } from 'mat-timepicker';
import { MatTooltipModule } from '@angular/material/tooltip';
import { MatCarouselModule } from 'ng-mat-carousel';

// mat Ngx Select Search

//Ngx Imports
import { NgxMatDatetimePickerModule, NgxMatNativeDateModule, NgxMatTimepickerModule } from '@angular-material-components/datetime-picker';
import { NgxSpinnerModule } from 'ngx-spinner';
import { NgxMatSelectModule } from './../../ngx-mat-select/ngx-mat-select.module';
import { PreventiveMaintenanceRoutingModule } from './preventive-maintenance-route.module';
import { PrevTaskFormComponent } from './prev-task-form/prev-task-form.component';
import { PrevTaskDialogComponent } from './prev-task-dialog/prev-task-dialog.component';
import { ScheduleTaskComponent } from './schedule-task/schedule-task.component';
import { PreventiveMaintananceConfigurationComponent } from './../../O3AdministrationComponents/ManufacturingAdminComponents/preventive-maintanance-configuration/preventive-maintanance-configuration.component';
import { PreventiveDialogComponent } from './../../O3AdministrationComponents/ManufacturingAdminComponents/preventive-maintanance-configuration/preventive-dialog/preventive-dialog.component';
import { ScheduleTaskDialogComponent } from './schedule-task/schedule-task-dialog/schedule-task-dialog.component';
import { SafetyModule } from '../../safety/safety.module';
import { TranslateModule } from '@ngx-translate/core';
import { AgGridModule } from 'ag-grid-angular';
import { BtnRenderer } from './../../btn-renderer.component';
import { BtnRendererActualEntry } from './../../btn-rendererActualEntry.component copy';
import { SharedModule } from "../../user-management/shared/shared.module";
import { MAT_DATE_LOCALE } from '@angular/material/core';
import { NGX_MAT_DATE_FORMATS } from '@angular-material-components/datetime-picker';
import { NgxMatDateAdapter } from '@angular-material-components/datetime-picker';
import { CustomNgxDatetimeAdapter } from 'src/app/services/custom-ngx-datetime-adapter.service';
import { CUSTOM_DATE_FORMATS } from 'src/app/services/custom-ngx-datetime-adapter.service';
import { MAT_MOMENT_DATE_ADAPTER_OPTIONS } from 'src/app/services/custom-ngx-datetime-adapter.service';
import { ChecklistDialogComponent } from 'src/app/O3AdministrationComponents/ManufacturingAdminComponents/preventive-maintanance-configuration/checklist-dialog/checklist-dialog.component';
import { ParamaterDialogComponent } from 'src/app/O3AdministrationComponents/ManufacturingAdminComponents/preventive-maintanance-configuration/paramater-dialog/paramater-dialog.component';
import { PrevTaskChecklistExecutionComponent } from './prev-task-checklist-execution/prev-task-checklist-execution.component';
import { PrevTaskExternalWorkComponent } from './prev-task-external-work/prev-task-external-work.component';
import { SubtasksDialogComponent } from './schedule-task/subtasks-dialog.component';
import { RescheduleTaskDialogComponent } from './schedule-task/reschedule-task-dialog/reschedule-task-dialog.component';
import { DatePickerCellEditorComponent } from './schedule-task/date-picker-cell-editor.component';
import { DatePickerFromCellEditorComponent } from './schedule-task/date-picker-from-cell-editor.component';
import { TechnicianDropdownCellEditorComponent } from './schedule-task/technician-dropdown-cell-editor/technician-dropdown-cell-editor.component';
import { ExternalVendorRendererComponent } from 'src/app/external-vendor-renderer.component';
import { TechnicianRendererComponent } from 'src/app/technician-renderer.component';
import { EditBtnRendererWO } from 'src/app/edit-action-btn-WO.component';
import { DialogModule } from 'primeng/dialog';
import { AngularImageViewerModule } from 'angular-x-image-viewer';
import { NgxDocViewerModule } from 'ngx-doc-viewer';

@NgModule({
  declarations: [
    PrevTaskFormComponent,
    PrevTaskDialogComponent,
    ScheduleTaskComponent,
    PreventiveMaintananceConfigurationComponent,
    PreventiveDialogComponent,
    ScheduleTaskDialogComponent,
    ChecklistDialogComponent,
    ParamaterDialogComponent,
    PrevTaskChecklistExecutionComponent,
    PrevTaskExternalWorkComponent,
    SubtasksDialogComponent,
    RescheduleTaskDialogComponent,
    DatePickerCellEditorComponent,
    DatePickerFromCellEditorComponent,
    TechnicianDropdownCellEditorComponent,
    ExternalVendorRendererComponent,
    TechnicianRendererComponent,
    EditBtnRendererWO
  ],
  schemas: [CUSTOM_ELEMENTS_SCHEMA],
  imports: [
    CommonModule,
    TranslateModule.forChild({
      extend: true,
    }),
    PreventiveMaintenanceRoutingModule,
    FormsModule,
    ReactiveFormsModule,
    //Material Imports
    MaterialModule,
    MatMenuModule,
    MatButtonModule,
    MatCheckboxModule,
    MatTableModule,
    MatPaginatorModule,
    MatSortModule,
    MatFormFieldModule,
    MatInputModule,
    MatTreeModule,
    MatCardModule,
    MatSelectModule,
    MatNativeDateModule,
    MatDatepickerModule,
    MatDialogModule,
    DialogModule,
    MaterialModule,
    MatExpansionModule,
    MatSlideToggleModule,
    MatTreeModule,
    MatTimepickerModule,
    MatTooltipModule,
    MatCarouselModule,
    AngularImageViewerModule,
    NgxDocViewerModule,
    //Ngx Imports
    NgxSpinnerModule,
    NgxMaterialTimepickerModule,
    NgxMatTimepickerModule,
    NgxMatDatetimePickerModule,
    NgxMatNativeDateModule,
    SafetyModule,
    AgGridModule.withComponents([BtnRenderer, BtnRendererActualEntry]),
    NgxMatSelectModule,
    SharedModule
  ],
  providers: [
    {
      provide: NgxMatDateAdapter,
      useClass: CustomNgxDatetimeAdapter,
      deps: [MAT_DATE_LOCALE, MAT_MOMENT_DATE_ADAPTER_OPTIONS]
    },
    { provide: NGX_MAT_DATE_FORMATS, useValue: CUSTOM_DATE_FORMATS }
  ],
})
export class PreventiveMaintenanceModule { }
